// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Header{display:flex;align-items:center;height:120px;max-width:1600px;margin-left:auto;margin-right:auto}@media(max-width: 1200px){.Header{align-items:flex-start}}.Header img{display:block;width:auto;height:100%}@media(max-width: 1200px){.Header img{height:auto}}.Header__title{max-width:511px;max-height:95px;margin-right:auto}@media(max-width: 1200px){.Header__title{margin-right:1em}}.Header__logo{height:100%;max-width:326px;margin-left:auto}", ""]);
// Exports
module.exports = exports;
